import { message } from 'antd';


export function orDash<T>(value: T | null | undefined): T | string {
  if (value === null || value === undefined) return '--';
  if (typeof value === 'string' && value.trim() === '') return '--';
  return value;
}

export function copyToClipboard(text: string | null | undefined, label = 'Valor'): void {
  if (!text) {
    message.warning(`${label} vazio, nada para copiar.`);
    return;
  }
  navigator.clipboard
    .writeText(text)
    .then(() => message.success(`${label} copiado para a área de transferência.`))
    .catch(() => message.error('Não foi possível copiar.'));
}
